export const NEWBUILDS_ESTATE_TYPE = ['apartment', 'house', 'house_apartment', 'parking', 'plot'];
